import { render, staticRenderFns } from "./TechTemplate.vue?vue&type=template&id=39df9cb0&scoped=true"
import script from "./TechTemplate.vue?vue&type=script&lang=js"
export * from "./TechTemplate.vue?vue&type=script&lang=js"
import style0 from "./TechTemplate.vue?vue&type=style&index=0&id=39df9cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df9cb0",
  null
  
)

export default component.exports